import { MyleTableColumnOptions } from "@/Common/Components/Tables/MyleTableColumn";
import { SortDirection } from "@/Common/Models/UI/Enums";
import { ITableRenderOptions } from "@/Common/Models/UI/Tables/ITableRenderOptions";

/**
 * Provides utility methods for Myle tables.
 */
class MyleTableHelper {
    /**
     * Get the sort direction to use when the user applies a column sort.
     * @param newColumn The selected column sort.
     * @param oldColumn The previous column sort, if any.
     * @param oldOrder The previous column order, if any.
     */
    public static getNewSortDir<TColumn extends number>(newColumn: TColumn, oldColumn: TColumn | null, oldOrder: SortDirection | null): SortDirection {
        // swap order on same column
        if (!IsNullOrUndefined(oldColumn) && !IsNullOrUndefined(oldOrder) && oldColumn === newColumn) {
            return oldOrder === SortDirection.DESC
                ? SortDirection.ASC
                : SortDirection.DESC;
        }

        // new sort
        return SortDirection.DESC;
    }

    public static getDefaultRenderOptions(columnOptions: MyleTableColumnOptions[]): ITableRenderOptions {
        return Immutable.fromJS({
            MinColWidth: 60,
            MinTableWidth: 980,
            Cols: columnOptions.filter(p => p.IsHidden === false).map(p => p.WidthPercentage),
            FirstColumnNoDrag: false,
            LastColumnNoDrag: true,
            Autoresize: true,
            OnColumnWidthChange: null
        });
    }
}

export { MyleTableHelper };
